// User/User.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "ADMIN";
  UserRole2["USER"] = "USER";
  return UserRole2;
})(UserRole || {});
var AccountDeletionBlocker = /* @__PURE__ */ ((AccountDeletionBlocker2) => {
  AccountDeletionBlocker2["ActiveDomains"] = "ACTIVE_DOMAINS";
  AccountDeletionBlocker2["OrderProcessing"] = "ORDER_PROCESSING";
  AccountDeletionBlocker2["AdminAccount"] = "ADMIN_ACCOUNT";
  AccountDeletionBlocker2["Impersonation"] = "IMPERSONATION";
  return AccountDeletionBlocker2;
})(AccountDeletionBlocker || {});

// User/Subscription.ts
var SubscriptionProduct = /* @__PURE__ */ ((SubscriptionProduct2) => {
  SubscriptionProduct2["staticSite"] = "staticSite";
  return SubscriptionProduct2;
})(SubscriptionProduct || {});
var SubscriptionStatus = /* @__PURE__ */ ((SubscriptionStatus2) => {
  SubscriptionStatus2["active"] = "active";
  SubscriptionStatus2["expired"] = "expired";
  SubscriptionStatus2["canceled"] = "canceled";
  SubscriptionStatus2["blocked"] = "blocked";
  return SubscriptionStatus2;
})(SubscriptionStatus || {});

// EPP/Poll.ts
var IEppPollMessageType = /* @__PURE__ */ ((IEppPollMessageType2) => {
  IEppPollMessageType2["TransferDomainComplete"] = "TransferDomainComplete";
  IEppPollMessageType2["Unknown"] = "Unknown";
  return IEppPollMessageType2;
})(IEppPollMessageType || {});

// Common/ICart.ts
var IPurchaseDomainType = /* @__PURE__ */ ((IPurchaseDomainType2) => {
  IPurchaseDomainType2["Registration"] = "Registration";
  IPurchaseDomainType2["Transfer"] = "Transfer";
  IPurchaseDomainType2["Renewal"] = "Renewal";
  IPurchaseDomainType2["Restore"] = "Restore";
  return IPurchaseDomainType2;
})(IPurchaseDomainType || {});

// Common/IContact.ts
var CommonContactType = /* @__PURE__ */ ((CommonContactType2) => {
  CommonContactType2["Individual"] = "Individual";
  CommonContactType2["Company"] = "Company";
  return CommonContactType2;
})(CommonContactType || {});

// Common/IOrder.ts
var StripePaymentStatus = /* @__PURE__ */ ((StripePaymentStatus2) => {
  StripePaymentStatus2["canceled"] = "canceled";
  StripePaymentStatus2["processing"] = "processing";
  StripePaymentStatus2["requires_action"] = "requires_action";
  StripePaymentStatus2["requires_capture"] = "requires_capture";
  StripePaymentStatus2["requires_confirmation"] = "requires_confirmation";
  StripePaymentStatus2["requires_payment_method"] = "requires_payment_method";
  StripePaymentStatus2["succeeded"] = "succeeded";
  return StripePaymentStatus2;
})(StripePaymentStatus || {});
function isEmptyOrder(order) {
  return order.domains.length === 0 && !order.staticHosting;
}

// Common/IProduct.ts
var ProductCategory = /* @__PURE__ */ ((ProductCategory2) => {
  ProductCategory2["domain"] = "domain";
  ProductCategory2["staticHosting"] = "staticHosting";
  return ProductCategory2;
})(ProductCategory || {});
var BillingInterval = /* @__PURE__ */ ((BillingInterval2) => {
  BillingInterval2["monthly"] = "monthly";
  BillingInterval2["yearly"] = "yearly";
  return BillingInterval2;
})(BillingInterval || {});

// Static/Plan.ts
var StaticPlanTier = /* @__PURE__ */ ((StaticPlanTier2) => {
  StaticPlanTier2["Free"] = "Free";
  StaticPlanTier2["Starter"] = "Starter";
  StaticPlanTier2["Business"] = "Business";
  return StaticPlanTier2;
})(StaticPlanTier || {});
var MB = 1024 * 1024;
var GB = 1024 * MB;
var STATIC_PLAN_LIMITS = {
  Free: {
    maxStorageBytes: 50 * MB,
    maxSitesPerAccount: 1,
    maxCustomDomains: 0,
    buildMinutesPerMonth: 0,
    canPublish: false
    // Cannot deploy publicly
  },
  Starter: {
    maxStorageBytes: 5 * GB,
    maxSitesPerAccount: 1,
    maxCustomDomains: 1,
    buildMinutesPerMonth: 120,
    canPublish: true
  },
  Business: {
    maxStorageBytes: 25 * GB,
    maxSitesPerAccount: 5,
    maxCustomDomains: 10,
    buildMinutesPerMonth: 600,
    canPublish: true
  }
};

// Static/Site.ts
var BUSINESS_PAGE_THEMES = ["light", "dark", "warm", "cool"];

// Static/Deployment.ts
var DeploymentStatus = /* @__PURE__ */ ((DeploymentStatus2) => {
  DeploymentStatus2["pending"] = "pending";
  DeploymentStatus2["uploaded"] = "uploaded";
  DeploymentStatus2["building"] = "building";
  DeploymentStatus2["built"] = "built";
  DeploymentStatus2["failed"] = "failed";
  return DeploymentStatus2;
})(DeploymentStatus || {});

// Static/PageSpeed.ts
function extractScores(response) {
  var _a, _b, _c, _d, _e;
  const categories = (_a = response.lighthouseResult) == null ? void 0 : _a.categories;
  return {
    performance: ((_b = categories == null ? void 0 : categories.performance) == null ? void 0 : _b.score) ?? null,
    accessibility: ((_c = categories == null ? void 0 : categories.accessibility) == null ? void 0 : _c.score) ?? null,
    bestPractices: ((_d = categories == null ? void 0 : categories["best-practices"]) == null ? void 0 : _d.score) ?? null,
    seo: ((_e = categories == null ? void 0 : categories.seo) == null ? void 0 : _e.score) ?? null
  };
}
function extractCoreWebVitals(response) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const audits = (_a = response.lighthouseResult) == null ? void 0 : _a.audits;
  if (!audits) return {};
  return {
    lcp: ((_b = audits["largest-contentful-paint"]) == null ? void 0 : _b.numericValue) ? audits["largest-contentful-paint"].numericValue / 1e3 : void 0,
    fcp: ((_c = audits["first-contentful-paint"]) == null ? void 0 : _c.numericValue) ? audits["first-contentful-paint"].numericValue / 1e3 : void 0,
    cls: (_d = audits["cumulative-layout-shift"]) == null ? void 0 : _d.numericValue,
    tbt: (_e = audits["total-blocking-time"]) == null ? void 0 : _e.numericValue,
    si: ((_f = audits["speed-index"]) == null ? void 0 : _f.numericValue) ? audits["speed-index"].numericValue / 1e3 : void 0,
    ttfb: (_g = audits["server-response-time"]) == null ? void 0 : _g.numericValue,
    inp: (_h = audits["experimental-interaction-to-next-paint"]) == null ? void 0 : _h.numericValue
  };
}

// Static/Template.ts
var TEMPLATE_CATEGORIES = [
  { id: "portfolio", label: "Portfolio" },
  { id: "business", label: "Business" },
  { id: "landing", label: "Landing Page" },
  { id: "personal", label: "Personal" },
  { id: "coming-soon", label: "Coming Soon" }
];

// Libs/Domain.ts
import { parse } from "tldts";
function normalizeHostOnly(host) {
  return String(host || "").trim().toLowerCase().replace(/\.$/, "").replace(/:\d+$/, "");
}
function isHostWithinDomain(host, domain) {
  const h = normalizeHostOnly(host);
  const d = normalizeHostOnly(domain);
  if (!h || !d) return false;
  return h === d || h.endsWith(`.${d}`);
}
function relativeLabelWithinDomain(host, domain) {
  const h = normalizeHostOnly(host);
  const d = normalizeHostOnly(domain);
  if (!isHostWithinDomain(h, d)) return null;
  if (h === d) return "";
  return h.slice(0, h.length - d.length - 1);
}
function isApexDomain(hostname) {
  const parsed = parse(hostname);
  return parsed.domain !== null && parsed.hostname === parsed.domain;
}
function getApexDomain(hostname) {
  const parsed = parse(hostname);
  return parsed.domain ?? "";
}
function getSubdomain(hostname) {
  const parsed = parse(hostname);
  return parsed.subdomain || null;
}
function extractHostFromUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.hostname;
  } catch {
    return null;
  }
}
var DOMAIN_RESTORE_WINDOW_DAYS = 39;
function domainRestorableUntil(deletedAt) {
  if (!deletedAt) return null;
  const deleted = new Date(deletedAt);
  if (Number.isNaN(deleted.getTime())) return null;
  return new Date(deleted.getTime() + DOMAIN_RESTORE_WINDOW_DAYS * 24 * 60 * 60 * 1e3);
}
function isDomainRestorable(domain, now = /* @__PURE__ */ new Date()) {
  if (!domain.deleted || domain.transferredAway) return false;
  const until = domainRestorableUntil(domain.deletedAt);
  return until !== null && now < until;
}

// Libs/Time.ts
var isoNow = () => {
  return (/* @__PURE__ */ new Date()).toISOString();
};
var renewedExpiryAfterCharge = (expirationDate, renewalCredits) => {
  const expiry = new Date(expirationDate);
  expiry.setFullYear(expiry.getFullYear() + Math.max(1, renewalCredits || 0));
  return expiry;
};

// Libs/File.ts
var FILE_UPLOAD_LIMITS = {
  maxFiles: 50,
  maxFileSize: 100 * 1024 * 1024,
  // 100 MB per file
  maxFileSizeLabel: "100 MB"
};
function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Libs/Gcs.ts
var TRANSIENT_ERROR_CODES = /* @__PURE__ */ new Set(["ECONNRESET", "ETIMEDOUT", "EPIPE", "ENOTFOUND", "EAI_AGAIN", "ECONNREFUSED", "ERR_STREAM_PREMATURE_CLOSE"]);
var TRANSIENT_ERROR_MESSAGE = /premature close|socket hang ?up|econnreset|etimedout|eai_again|network socket disconnected/i;
function isTransientError(err) {
  if (!err || typeof err !== "object") return false;
  const code = err.code;
  if (typeof code === "string" && TRANSIENT_ERROR_CODES.has(code)) return true;
  const message = err.message;
  return typeof message === "string" && TRANSIENT_ERROR_MESSAGE.test(message);
}
export {
  AccountDeletionBlocker,
  BUSINESS_PAGE_THEMES,
  BillingInterval,
  CommonContactType,
  DOMAIN_RESTORE_WINDOW_DAYS,
  DeploymentStatus,
  FILE_UPLOAD_LIMITS,
  IEppPollMessageType,
  IPurchaseDomainType,
  ProductCategory,
  STATIC_PLAN_LIMITS,
  StaticPlanTier,
  StripePaymentStatus,
  SubscriptionProduct,
  SubscriptionStatus,
  TEMPLATE_CATEGORIES,
  UserRole,
  domainRestorableUntil,
  extractCoreWebVitals,
  extractHostFromUrl,
  extractScores,
  formatFileSize,
  getApexDomain,
  getSubdomain,
  isApexDomain,
  isDomainRestorable,
  isEmptyOrder,
  isHostWithinDomain,
  isTransientError,
  isoNow,
  normalizeHostOnly,
  relativeLabelWithinDomain,
  renewedExpiryAfterCharge
};
